import React from 'react'
import {
  AutocompleteInput,
  Create,
  Datagrid,
  Edit,
  EditButton,
  List,
  ReferenceField,
  ReferenceInput,
  Show,
  ShowButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput
} from 'react-admin'

const filters = [
  <ReferenceInput label="Coin" source="coin_id" reference="coins" alwaysOn>
    <AutocompleteInput optionText="name" />
  </ReferenceInput>,
  <ReferenceInput label="Treasury entity" source="treasury_entity_id" reference="treasury_entities" alwaysOn>
    <AutocompleteInput optionText="name" />
  </ReferenceInput>,
]

const TreasuryList = props => (
  <List {...props} filters={filters}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="amount" />
      <ReferenceField label="Coin" source="coin_id" reference="coins">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="Treasury Entity" source="treasury_entity_id" reference="treasury_entities">
        <TextField source="name" />
      </ReferenceField>
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
)

const TreasuryEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="amount" />
      <ReferenceInput label="Coin" source="coin_id" reference="coins">
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="Treasury Entity" source="treasury_entity_id" reference="treasury_entities">
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
)

const TreasuryCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="amount" />
      <ReferenceInput label="Coin" source="coin_id" reference="coins">
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="Treasury Entity" source="treasury_entity_id" reference="treasury_entities">
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
)

const TreasuryShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="amount" />
      <ReferenceField label="Coin" source="coin_id" reference="coins">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="Treasury Entity" source="treasury_entity_id" reference="treasury_entities">
        <TextField source="name" />
      </ReferenceField>
    </SimpleShowLayout>
  </Show>
)

export { TreasuryList, TreasuryEdit, TreasuryCreate, TreasuryShow }
